import clsx from 'clsx'
import { useState, type ReactNode } from 'react'
import { View } from 'react-native'

import { Image } from '@/src/elements/image'
import { TEST_ID } from '@/src/general/constants/testId'
import { useTimeout } from '@/src/general/hooks/useTimeout'

import type { TCandleProps } from './Candle.type'
import { candleClassName, candleDuration } from './constants'

export const Candle = ({ onFinish, enabled, testID }: TCandleProps): ReactNode => {
  const [isFinished, setIsFinished] = useState(false)

  useTimeout(
    () => {
      onFinish()
      setIsFinished(true)
    },
    enabled ? candleDuration : null,
  )

  return (
    <View
      testID={testID || (isFinished ? TEST_ID.PRAY.CANDLE.FULL : TEST_ID.PRAY.CANDLE.PENDING)}
      className="h-[300px] w-[73px] items-center"
    >
      {/** transition={null} because the default transition (cross-dissolve) introduce a bug when the candle becomes disabled (in intentions pray flow) */}
      <Image source={require('@/img/prayer/candle/empty.png')} className="absolute" transition={null} />
      <Image
        source={require('@/img/prayer/candle/full.png')}
        className={clsx({ 'opacity-0': !enabled, [candleClassName]: enabled })}
        transition={null}
      />
    </View>
  )
}
